export default __webpack_public_path__ + "static/media/1334.1bd076dd.png";